var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51,5.71H12.5a4,4,0,0,0-4,4v12a4,4,0,0,0,4,4h4V55.77a5.8,5.8,0,0,0,5.6,6,1.91,1.91,0,0,0,.68-.13h0l.21-.1.15-.07,13.38-8,13.11,7.84a2.33,2.33,0,0,0,1,.42h.08l.17,0h.23c2.95-.14,5.32-2.91,5.32-6.32V12.06C56.49,8.57,54,5.71,51,5.71Zm-38.45,16v-12H50.94c.73,0,1.55,1,1.55,2.34V55.39a2.41,2.41,0,0,1-1.13,2.23L38,49.61a2,2,0,0,0-.3-.14,2,2,0,0,0-2.14-.06L21.72,57.67a2,2,0,0,1-1.19-1.9V19.86a2,2,0,0,0-4,0v1.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.85,28.24H30.51a1.92,1.92,0,0,0,0,3.84h4.08v3.48H30.51a1.93,1.93,0,0,0,0,3.85h4.08v4.26a2,2,0,0,0,4,0V39.41h4.08a1.93,1.93,0,0,0,0-3.85H38.59V32.08h4.08a1.92,1.92,0,1,0,0-3.84H39.32L46.55,21a2,2,0,0,0-2.83-2.83l-7.13,7.13L29.46,18.2A2,2,0,0,0,26.64,21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.77f3234e.svg";
export { ForwardRef as ReactComponent };